module.exports = __webpack_public_path__ + "static/media/show_video.d6fcc4f3.mp4";